import { QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const peerRatingsKeys = new QueryKeyFactoryGenerator('peer-ratings').getDefault();
